module.exports = __webpack_public_path__ + "img/logo-sp-mania.11411c73.svg";